import React, { useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { useForm, ValidationError } from '@formspree/react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './Contact.scss';

const Contact = () => {
    const [state, handleSubmit] = useForm("mrbqvylw");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
        services: {
            llmRag: false,
            computerVision: false,
            mlops: false,
            aiPlatform: false
        }
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData(prevState => ({
                ...prevState,
                services: {
                    ...prevState.services,
                    [name]: checked
                }
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = {
            ...formData,
            services: Object.entries(formData.services)
                .filter(([_, value]) => value)
                .map(([key]) => key)
                .join(', ')
        };
        
        try {
            await handleSubmit(formDataToSend);
            if (state.succeeded) {
                navigate('/contact/submit');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    return (
        <div className="contact-page">
            <Helmet>
                <title>Contact Majority AI - Get in Touch | AI Solutions Inquiry</title>
                <meta name="description" content="Contact Majority AI for machine learning and AI solutions. Get expert consultation for LLM/RAG, computer vision, and custom AI development projects." />
                <meta name="keywords" content="contact MajorityAI, AI consultation inquiry, machine learning services contact, get in touch\" />
                <link rel="canonical" href="https://www.majorityai.com/contact" />
            </Helmet>
            <Navbar />
            <div className="contact-section">
                <div className="contact-container">
                    <div className="contact-info">
                        <h2>Get in Touch</h2>
                        <p>We transform AI ideas into pragmatic solutions. Let's build your future together.</p>
                        
                        <div className="info-item">
                            <div className="icon">
                                <FaEnvelope />
                            </div>
                            <div className="content">
                                <h3>Email Us</h3>
                                <p>connorxiong.ai@gmail.com</p>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form">
                        <h2>Send Us a Message</h2>
                        <form onSubmit={onSubmit}>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">Name <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Your name"
                                        required
                                    />
                                    <ValidationError prefix="Name" field="name" errors={state.errors} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone <span className="required">*</span></label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="Your phone number"
                                        required
                                    />
                                    <ValidationError prefix="Phone" field="phone" errors={state.errors} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email <span className="required">*</span></label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your email"
                                    required
                                />
                                <ValidationError prefix="Email" field="email" errors={state.errors} />
                            </div>
                            <div className="form-group">
                                <label>Interested Services</label>
                                <div className="checkbox-group">
                                    <div className="checkbox-item">
                                        <input
                                            type="checkbox"
                                            id="llm"
                                            name="llmRag"
                                            checked={formData.services.llmRag}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="llm">LLM + RAG / Agents Solutions</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            type="checkbox"
                                            id="vision"
                                            name="computerVision"
                                            checked={formData.services.computerVision}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="vision">Computer Vision Solutions</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            type="checkbox"
                                            id="mlops"
                                            name="mlops"
                                            checked={formData.services.mlops}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="mlops">MLOps & Deployment</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            type="checkbox"
                                            id="platform"
                                            name="aiPlatform"
                                            checked={formData.services.aiPlatform}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="platform">Help me turn my AI idea into a real product</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="message">Enter Details <span className="required">*</span></label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Please describe your project requirements..."
                                    required
                                />
                                <ValidationError prefix="Message" field="message" errors={state.errors} />
                            </div>
                            <button type="submit" className="submit-button" disabled={state.submitting}>
                                {state.submitting ? 'Sending...' : 'Send Message'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contact; 